import React, {useState} from 'react';
import {Player} from './types';

export interface CollectedAnswer {
    playerId: string;
    playerName: string;
    text: string;
}

interface Props {
    players: Player[];
    prompt: React.ReactNode;
    placeholder?: string;
    submitLabel?: string;
    onDone: (answers: CollectedAnswer[]) => void;
}

/** Passes the phone player-by-player, collecting one private text answer from each. */
const CollectAnswers: React.FC<Props> = ({players, prompt, placeholder = 'Твой ответ', submitLabel, onDone}) => {
    const [index, setIndex] = useState(0);
    const [ready, setReady] = useState(false);
    const [draft, setDraft] = useState('');
    const [answers, setAnswers] = useState<CollectedAnswer[]>([]);

    const player = players[index];
    const isLast = index + 1 >= players.length;

    const submit = () => {
        const text = draft.trim();
        if (!text) return;
        const next = [...answers, {playerId: player.id, playerName: player.name, text}];
        setAnswers(next);
        setDraft('');
        if (isLast) {
            onDone(next);
        } else {
            setIndex(index + 1);
            setReady(false);
        }
    };

    if (!ready) {
        return (
            <div className="GmPassCard">
                <p className="GmPassCard-hint">Передайте телефон игроку</p>
                <h2 className="GmPassCard-name">{player.name}</h2>
                <button className="GmBtn GmBtn--primary GmBtn--big" onClick={() => setReady(true)}>
                    Я — {player.name}, посмотреть
                </button>
                <p className="GmPassCard-progress">{index + 1} / {players.length}</p>
            </div>
        );
    }

    return (
        <div className="GmCard">
            <p className="GmHint GmHint--warn">⚠ Не показывайте экран остальным!</p>
            <div style={{marginBottom: 12}}>{prompt}</div>
            <input
                className="GmInput"
                placeholder={placeholder}
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') submit();
                }}
            />
            <div style={{marginTop: 16}}>
                <button className="GmBtn GmBtn--primary GmBtn--big" disabled={!draft.trim()} onClick={submit}>
                    {submitLabel || (isLast ? 'Готово' : 'Скрыть и передать дальше')}
                </button>
            </div>
        </div>
    );
};

export default CollectAnswers;
